export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const isAdmin = () => {
  const user = getUser();
  return user && user.role === 'admin';
};

export const isApprovedCustomer = () => {
  const user = getUser();
  return user && user.role === 'customer';
};

export const login = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

/**
 * Navigate to booking for a hairstyle, handling all auth states.
 * Returns { action, path } where action is 'navigate' or 'toast'.
 */
export const getBookingAction = (hairstyleId) => {
  if (!isAuthenticated()) {
    return {
      action: 'navigate',
      path: `/login?redirect=${encodeURIComponent(`/booking?hairstyle=${hairstyleId}`)}`
    };
  }
  const user = getUser();
  if (user?.role === 'admin') {
    return { action: 'toast', message: 'Admins cannot book appointments.' };
  }
  return { action: 'navigate', path: `/booking?hairstyle=${hairstyleId}` };
};
